import React from 'react';
import { NewsCardItem } from './NewsCardItem';
import Hooks from '@benzinga/hooks';
import styled from '@benzinga/themetron';
import { WordpressPost } from '@benzinga/content-manager';

interface Props {
  blocks?: WordpressPost[];
  blocksShowCount?: number;
}

export const RecentNewsBlock = ({ blocks, blocksShowCount = 3 }: Props) => {
  const { width } = Hooks.useWindowSize();

  if (!blocks?.length) return null;

  return (
    <BlockWrapper className="block-wrapper">
      {blocks.slice(0, width >= 960 ? blocksShowCount : blocks.length).map(card => (
        <NewsCardItem card={card} className="card" key={card.id} variant="default" />
      ))}
    </BlockWrapper>
  );
};

const BlockWrapper = styled.div`
  &.block-wrapper {
    max-width: 100%;
    display: flex;
    align-items: stretch;
    gap: 16px;

    @media screen and (max-width: 959px) {
      overflow-x: scroll;
      -ms-overflow-style: none; /* for Internet Explorer, Edge */
      scrollbar-width: none; /* for Firefox */
    }

    &::-webkit-scrollbar {
      display: none; /* for Chrome, Safari, and Opera */
    }
  }

  .card {
    flex: 1;
  }
`;
